/**
 * Setup dragenter, dragover, dragleave, drop events on the given element
 */
export class DragHandler {
	/**
	 * Setup the drag zone
	 * @param {HTMLElement} element  The element to set up as the drag zone
	 * @param {Object} options  Setup info
	 * @property {String} hoverClassName  The name of the CSS class to apply and remove on the drag zone
	 * @property {Function<Event>} ondragenter  The callback for the mouseenter on a draggable item
	 * @property {Function<Event>} ondragleave  The callback for the mouseleave on a draggable item
	 * @property {Function<Event>} ondrop  The callback for the drop
	 */
	constructor(element, options) {
		// vars first and second are used to prevent dragenter and dragleave to be fired multiple times on child elements
		// see https://github.com/bensmithett/dragster/blob/6f7032218cc29ae4931769380c3a559053043608/lib/dragster.js
		let first = false;
		let second = false;
		const onDragenter = evt => {
			if (first) {
				second = true;
				return;
			}
			first = true;
			element.classList.add(options.hoverClassName);
			options.ondragenter && options.ondragenter(evt);
		};
		const onDragover = evt => {
			evt.preventDefault();
		};
		const onDragleave = evt => {
			if (second) {
				second = false;
			} else if (first) {
				first = false;
			}
			if (!first && !second) {
				element.classList.remove(options.hoverClassName);
				options.ondragleave && options.ondragleave(evt);
			}
		};
		const onDrop = evt => {
			evt.preventDefault();
			first = false;
			second = false;
			element.classList.remove(options.hoverClassName);
			options.ondrop && options.ondrop(evt);
		};
		element.addEventListener('drop', onDrop, false);
		element.addEventListener('dragover', onDragover, false);
		element.addEventListener('dragenter', onDragenter, false);
		element.addEventListener('dragleave', onDragleave, false);
		// allow later teardown
		this._removeDropListeners = () => {
			element.removeEventListener('drop', onDrop);
			element.removeEventListener('dragover', onDragover);
			element.removeEventListener('dragenter', onDragenter);
			element.removeEventListener('dragleave', onDragleave);
		};
	}

	/**
	 * Remove all handlers from the drop zone
	 */
	teardown() {
		try {
			this._removeDropListeners();
		} catch (e) {
			console.debug('Error removing DragHandler drop listener');
		}
	}
}
